var _path;
import * as React from "react";
function SvgWavePulse(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.977 5.6a.9.9 0 01.895.68l4.725 18.9 2.115-5.281a2.702 2.702 0 012.509-1.7H37.1c.495 0 .9.406.9.9 0 .496-.405.9-.9.9h-6.88a.91.91 0 00-.837.57l-3.15 7.868a.9.9 0 01-.895.563.9.9 0 01-.81-.68L20.101 10.6 15.49 33.675a.9.9 0 01-1.755.045l-3.268-13.038A.892.892 0 009.594 20H2.9a.903.903 0 01-.9-.9c0-.495.405-.9.9-.9h6.694c1.237 0 2.317.844 2.621 2.047l2.29 9.152 4.612-23.073a.9.9 0 01.86-.726z"
  })));
}
export default SvgWavePulse;